const fallbackStats = [
  { value: "35%", label: "Avg. Cost Reduction" },
  { value: "80%", label: "Avg. Faster Procurement" },
  { value: "15K+", label: "Avg. Hours Saved" },
];

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "9px 12px",
  border: "1.5px solid #e2e8f0",
  borderRadius: 8,
  fontSize: 14,
  color: "#1e293b",
  background: "#fff",
};

export default function HeroStatsEditor({ stats = fallbackStats, onChange }) {
  const updateStat = (index, key, value) => {
    onChange(stats.map((stat, statIndex) => (
      statIndex === index ? { ...stat, [key]: value } : stat
    )));
  };

  return (
    <div style={{ padding: 14, border: "1px solid #e2e8f0", borderRadius: 8, background: "#f8fafc", marginBottom: 16 }}>
      <p style={{ margin: "0 0 4px", fontSize: 13, color: "#64748b" }}>
        Changes are saved with the page using the Save Page Content button.
      </p>
      {stats.map((stat, index) => (
        <div key={index} style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: 10, marginTop: 10 }}>
          <input aria-label={`Metric ${index + 1} value`} style={inputStyle} value={stat.value || ""} onChange={(event) => updateStat(index, "value", event.target.value)} />
          <input aria-label={`Metric ${index + 1} label`} style={inputStyle} value={stat.label || ""} onChange={(event) => updateStat(index, "label", event.target.value)} />
        </div>
      ))}
    </div>
  );
}
